import { FormController } from "$root/third-party-integrations/react-hook-form";
import { valueByPath } from "$root/utils";
import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { type PasswordInputProps, PasswordInput, FormField } from "@mdotm/shadcn/mdotm/components";
import type { ReactNode } from "react";
import type { Control, FieldValues, FormState, Path } from "react-hook-form";

export type PasswordFieldProps<T extends FieldValues> = StylableProps & {
	control: Control<T, any>;
	formState: FormState<T>;
	name: Path<T>;
	label: ReactNode;
} & Omit<PasswordInputProps, "value">;

export function PasswordField<T extends FieldValues>({
	label,
	name,
	formState,
	control,
	className,
	style,
	...forward
}: PasswordFieldProps<T>): React.JSX.Element {
	return (
		<FormField
			className={className}
			style={style}
			label={label}
			error={(valueByPath(formState.errors, name) as { message?: string })?.message}
		>
			{(fieldProps) => (
				<FormController
					control={control}
					name={name}
					render={({ field: { ref, ...controllerProps } }) => (
						<PasswordInput innerRef={ref} {...fieldProps} {...controllerProps} {...forward} />
					)}
				/>
			)}
		</FormField>
	);
}
